import { z } from 'zod';
export const GeneratedArtefactKindSchema = z.enum([
    'final-report-pdf',
    'signed-consent-pdf',
    'notification-of-issues-pdf',
]);
export const GeneratedArtefactStatusSchema = z.enum(['draft', 'final']);
export const InspectorPdfIdentitySchema = z.object({
    userId: z.string().min(1),
    displayName: z.string().trim().min(1),
    legalName: z.string().trim().min(1),
    cerRegistrationNumber: z.string().trim().min(1),
});
/** Immutable metadata stored beside every generated PDF. */
export const GeneratedArtefactSchema = z.object({
    artefactId: z.string().uuid(),
    jobId: z.string().min(1),
    reportSubmittedAt: z.string(),
    kind: GeneratedArtefactKindSchema,
    status: GeneratedArtefactStatusSchema,
    templateId: z.string().min(1),
    templateVersion: z.string().min(1),
    sourceSnapshotSha256: z.string().length(64),
    pdfSha256: z.string().length(64),
    signatureSha256: z.string().length(64).optional(),
    storageKey: z.string().min(1),
    generatedAt: z.string(),
    generatedByUserId: z.string().min(1),
    supersedesArtefactId: z.string().uuid().optional(),
});
export const GENERATED_ARTEFACT_TEMPLATE_VERSIONS = {
    finalReport: 'pwa-final-report-v1',
    notificationOfIssues: 'notification-of-issues-v1',
    consentPvOnly: 't45-pv-only-v1',
    consentPvBattery: 't45-pv-battery-v1',
};
//# sourceMappingURL=generated-artifacts.js.map